import { http } from './httpClient'
import type {
  AdminAnnouncement,
  AnnouncementAudiencePreview,
  AnnouncementContent,
  AnnouncementDelivery,
  AnnouncementMetrics,
  Paginated,
} from './types'

export type AnnouncementDraft = Pick<
  AdminAnnouncement,
  | 'title'
  | 'body'
  | 'severity'
  | 'cta_text'
  | 'cta_url'
  | 'ends_at'
  | 'audience_type'
  | 'target_workspace'
  | 'segment_type'
  | 'segment_params'
>

export const announcementApi = {
  inbox: () => http.get<Paginated<AnnouncementDelivery>>('/api/announcement-deliveries/'),
  markSeen: (id: number) =>
    http.post<AnnouncementDelivery>(`/api/announcement-deliveries/${id}/mark-seen/`),
  dismiss: (id: number) => http.post<void>(`/api/announcement-deliveries/${id}/dismiss/`),
  dismissAll: () =>
    http.post<{ dismissed: number }>('/api/announcement-deliveries/dismiss-all/'),
  listAdmin: (query?: Record<string, string | number | undefined>) =>
    http.get<Paginated<AdminAnnouncement>>('/api/admin/announcements/', { query }),
  create: (body: AnnouncementDraft) =>
    http.post<AdminAnnouncement, AnnouncementDraft>('/api/admin/announcements/', body),
  update: (id: number, body: Partial<AnnouncementDraft> & { is_active?: boolean }) =>
    http.patch<AdminAnnouncement, Partial<AnnouncementDraft>>(`/api/admin/announcements/${id}/`, body),
  preview: (id: number) =>
    http.get<AnnouncementAudiencePreview>(`/api/admin/announcements/${id}/audience-preview/`),
  sendTest: (id: number) =>
    http.post<AnnouncementContent>(`/api/admin/announcements/${id}/send-test/`),
  send: (id: number, preview: AnnouncementAudiencePreview) =>
    http.post<AdminAnnouncement>(`/api/admin/announcements/${id}/send/`, {
      audience_count: preview.count,
      audience_fingerprint: preview.fingerprint,
    }),
  metrics: (id: number) =>
    http.get<AnnouncementMetrics>(`/api/admin/announcements/${id}/metrics/`),
}
